import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { isTextTemplateSelected } from '../useTestVariables.utils'

import {
  getAddedDocTemplate,
  hasFilledRecipients,
} from './useTestVariablesAutoCheck.utils'

export function useTestVariablesAutoCheck({
  docTemplateCheckRef,
  docTemplates,
  mass,
  textTemplate,
  onTestEmailTextTemplateVariables,
  onTestGoogleVariables,
}) {
  const { values } = useFormikContext()

  const checkedTextTemplateRef = useRef(textTemplate)
  const checkedDocTemplatesRef = useRef(docTemplates)

  function resolveDocTemplateCheck(hasMissingVariables) {
    docTemplateCheckRef.current?.(hasMissingVariables)
    docTemplateCheckRef.current = null
  }

  useEffect(() => {
    if (
      mass &&
      isTextTemplateSelected(textTemplate) &&
      textTemplate !== checkedTextTemplateRef.current &&
      hasFilledRecipients(values)
    ) {
      onTestEmailTextTemplateVariables({ isAutoCheck: true })
    }

    checkedTextTemplateRef.current = textTemplate
  }, [textTemplate])

  useEffect(() => {
    const addedDocTemplate = getAddedDocTemplate({
      docTemplates,
      prevDocTemplates: checkedDocTemplatesRef.current,
    })

    if (addedDocTemplate && hasFilledRecipients(values)) {
      onTestGoogleVariables({
        isAutoCheck: true,
        templates: [addedDocTemplate],
      }).then(resolveDocTemplateCheck)
    } else {
      resolveDocTemplateCheck(false)
    }

    checkedDocTemplatesRef.current = docTemplates
  }, [docTemplates])
}
